export default {
    copy: {
        macrotrend: {
            success: 'Macro-trend "{title}" copied successfully'
        },
        megatrend: {
            success: 'Mega-trend "{title}" copied successfully'
        }
    },
    toggle: {
        macrotrend: {
            deactivated: 'Trend "{title}" has been activated. In the course of this, the following predecessors of this trend were automatically deactivated:'
        }
    },
    activate: {
        currentUniverse: 'All new trends (publication year 2024) were activated successfully'
    },
    deactivate: {
        all: 'All trends were deactivated successfully'
    }
}
